export const ErrorHandler = ({ is500, is400}) => {
    if (is500) {
        return <div>A 500 error occurred</div>
    }
}
